import collectionPoster from '@/assets/images/autumn-harvest-collection.png';







export const order = 4;

export default {
  collection_name: 'Autumn Harvest Collection',
  collection_desc:
    'The Autumn Harvest Flooring Collection features rich, warm wood tones inspired by the colors of fall. With natural textures and timeless design, this collection creates cozy, stylish interiors while offering durable flooring built for everyday living.',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Seashell Mist',
      sku: 'AHJ17',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Seashell Mist'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Steel Cloud',
      sku: 'AHJ18',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud5.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud6.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Steel Cloud'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Honey Comb',
      sku: 'AHJ19',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb5.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb6.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb7.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Honey Comb'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
